import { Routes, Route, Navigate } from "react-router";
import { useMemo } from "react";
import Info from "./Info/Info";
import Detail from "./Info/Detail";
function PageRoter() {
  const info = useMemo(() => <Info />, []);
  const infoDetail = useMemo(() => <Detail />, []);
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/info" replace />} />
      <Route path="/info" element={infoDetail} />
      <Route path="/info/:add/:name/:bToken/:network" element={infoDetail} />
    </Routes>
  );
}
export default PageRoter;
